import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import VolunteerServiceContext from '../VolunteerServiceContext';
import { createRestContext } from './create-rest-context';
const VolunteerServiceProvider = ({ uri, appSecret, children, }) => {
    const provider = useMemo(() => createRestContext(uri, appSecret !== null && appSecret !== void 0 ? appSecret : ''), [uri, appSecret]);
    return (_jsx(VolunteerServiceContext.Provider, Object.assign({ value: provider }, { children: children })));
};
export { VolunteerServiceProvider };
